module.exports = __webpack_public_path__ + "static/media/5.4470a42e.svg";